export default __webpack_public_path__ + "static/media/Trust-Spectrum-Logo.75cc874f.png";